export const ACCESS_TOKEN_COOKIE_KEY = 'wisbits_access_token';
export const REFRESH_TOKEN_COOKIE_KEY = 'wisbits_refresh_token';

// eslint-disable-next-line no-undef
export const API_URL = process.env.REACT_APP_API_URL;
